import { get } from 'lodash';
import {
    CLOSE_SNACKBAR,
    OPEN_SNACKBAR
} from './types/snackbar-action-types';

import { SNACKBAR_TYPES } from '../constants/ui-options';
import { buildDomainManagementBulkSuccessMessage } from '../../utils/common-utils';

export function openSuccessSnackbar( additionalOptions = null ){
    return openSnackbar( SNACKBAR_TYPES.success, additionalOptions );
}

export function openErrorSnackbar( additionalOptions = null ){
    return openSnackbar( SNACKBAR_TYPES.error, additionalOptions );
}

export const openSnackbar = ( snackbarType, additionalOptions = null ) => {
    return {
        additionalOptions,
        snackbarType,
        type: OPEN_SNACKBAR,
    };
};

export const closeSnackbar = () => {
    return {
        type: CLOSE_SNACKBAR
    };
};

export function openExportToImageErrorSnackbar(){
    return openErrorSnackbar( { message: `We couldn't download the image. Please try again later.` } );
}


// Domain Management
export function openDomainManagementBulkSuccessSnackbar( successfulDomainsTotal, domainActionType, domainType ){
    const snackbarMessage = buildDomainManagementBulkSuccessMessage(
        successfulDomainsTotal,
        domainActionType,
        domainType
    );
    return openSuccessSnackbar( { actionCloseButton: true, message: snackbarMessage } );
}

export function openDomainManagementBulkErrorSnackbar( domainActionType ){
    const DOMAIN_ACTION_TYPE_MAP = {
        add: 'adding domains',
        changeType: 'changing domain type',
        claim: 'claiming domains',
        remove: 'removing domains',
    };
    return openErrorSnackbar( { message: `A server error occurred. Try ${DOMAIN_ACTION_TYPE_MAP[domainActionType]} later.` } );
}

// Domain Grouping: Success
export function openDomainGroupingCreateSuccessSnackbar( group ){
    const domains = get( group, 'domains', [] );
    const plural = domains.length === 1 ? 'domain' : 'domains';

    return openSuccessSnackbar( {
        actionCloseButton: true,
        message: `Created ${group.name} with ${domains.length} ${plural}.`,
    } );
}
export function openDomainGroupingEditSuccessSnackbar( group ){
    const domains = get( group, 'domains', [] );
    const plural = domains.length === 1 ? 'domain' : 'domains';

    return openSuccessSnackbar( {
        actionCloseButton: true,
        message: `${group.name} now has ${domains.length} ${plural}.`,
    } );
}
export function openDomainGroupingDeleteSuccessSnackbar( groupName ){
    return openSuccessSnackbar( {
        actionCloseButton: true,
        message: `Domain group: ${groupName} has been deleted.`,
    } );
}

// Domain Grouping: Error
export function openDomainGroupingSaveErrorSnackbar(){
    return openErrorSnackbar( { message: `A server error occurred. Try modifying domain groups later.` } );
}
export function openDomainGroupingDeleteErrorSnackbar( ){
    return openErrorSnackbar( { message: `A server error occurred. Try deleting domain groups later` } );
}

// Remove Domains
export function openRemoveDomainsFromGroupsSuccessSnackbar(){
    return openSuccessSnackbar( { message: `Domains were successfully removed from groups.` } );
}
export function openRemoveDomainsFromGroupsErrorSnackbar(){
    return openErrorSnackbar( { message: `Some domains could not be removed from groups.` } );
}

// Senders
export function openUpdateRecognizedSendersSuccessSnackbar(){
    return openSuccessSnackbar();
}
export function openUnverifiedSenderWarningSnackbar( senderName ){
    return openSuccessSnackbar( { message: `${senderName} is no longer a permitted sender.` } );
}
